import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('emailTemplateTypes', {
  resource () {
    return {
      id: mapped(null),
      type: mapped(null),
      title: mapped(null),
    }
  }
})
